import withAemIntegration from "../../../../withAemIntegration";
import loadable from "../../../../utils/loadable";

const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/DriversNewAccountForm")
);

const ComponentEditConfig = {
  emptyLabel: "Create an Account",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const CreateAccount = (props) => {
  return <Component {...props} />;
};

export default withAemIntegration(
  "lexus/components/drivers/forms/create-account"
)(CreateAccount, ComponentEditConfig);
